import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_app_left_nav_h = _resolveComponent("app-left-nav-h")!

  return (_openBlock(), _createBlock(_component_app_left_nav_h, null, {
    top: _withCtx(() => [
      _createVNode(_component_el_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_tooltip, {
            placement: "right",
            content: "Matched Opportunities"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/opportunities/matched" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, null, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "el-icon-search" }, null, -1),
                      _createElementVNode("span", null, "Matched", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tooltip, {
            placement: "right",
            content: "Active Opportunities"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/opportunities/active" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, null, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "el-icon-s-opportunity" }, null, -1),
                      _createElementVNode("span", null, "Active", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/biddings?status=ongoing" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "el-icon-document" }, null, -1),
                  _createElementVNode("span", null, "Bids", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    bottom: _withCtx(() => [
      _createVNode(_component_el_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/account/account" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/account" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("span", null, "Account", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/account/profile" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/account/profile" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("span", null, "Profile", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}